import { createAsyncThunk } from "@reduxjs/toolkit";
import { axios } from "config/api";

const BASE_URL = "/scores";

export const fetchScores = createAsyncThunk("scores/filtered", async () => {
  try {
    const response = await axios.get(`${BASE_URL}/filtered`);
    return response.data.data;
  } catch (error: any) {
    console.log("Error - getScores ->", error);
    throw new Error(error.message);
  }
});
